import React, { useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
// @ts-ignore
import useDeviceType from "../../../../Hooks/ResponsiveHook";
import _ from "lodash";

import PopoverCustom from "components/PriorityApp/SimpleView/PopoverCustom";

// @ts-ignore
import UnitsSelector from "../../Measurement/UnitsSelector";

import InputAreaAI from "components/InputAreaAI";

// @ts-ignore
import { UpdateGoal } from "Redux/UpdateGoal/action.js";

// @ts-ignore
import { CreateMetricsPopup, ManageMetricsPopup } from "../../Measurement/ManageMetrics/index";

import { PopoverToggle } from "./styled";

interface MeasurementFormProps {
  item: any;
  index: number;
  customMetrics: any[];
}

// Helper function to find unit by ID from flattened list
function flattenList(list: any[]) {
  return list.reduce((acc: any[], item: any) => {
    if (item.children && item.children.length > 0) {
      acc = acc.concat(item.children);
    }
    return acc;
  }, []);
}

const MeasurementForm: React.FC<MeasurementFormProps> = ({
  item,
  index: i,
  customMetrics,
}) => {
  const dispatch = useDispatch();
  const screenSizes = useDeviceType();
  const isMobile = screenSizes === "mobile";

  const [isAssistantOpen, setIsAssistantOpen] = useState(false);
  const [isAddCustomMetric, setIsAddCustomMetric] = useState(false);
  const [isManageMetric, setIsManageMetric] = useState(false);

  const { data: predefinedMetrics } = useSelector(
    (state: any) => state.predefinedMetricsReducer
  );

  const $measurement = useRef<any>();

  const findUnitById = (id: string) => {
    const allMetrics = [...predefinedMetrics, ...customMetrics];
    const flattenedUnits = flattenList(allMetrics);
    return flattenedUnits.find((unit: any) => unit.key === id || unit.id === id);
  };

  const onAddMetricPopupOpenHandle = (value: boolean) => {
    setIsAddCustomMetric(value);
  };

  const onAddMetricPopupCloseHandle = () => {
    setIsAddCustomMetric(false);
  };

  const onManageToggleHandle = () => {
    setIsManageMetric((prev) => !prev);
  };

  const onUnitsChangeHandle = (e: any) => {
    if (e.key === "custom") onAddMetricPopupOpenHandle(true);
    else if (e.key === "manage") onManageToggleHandle();
    else {
      const unit = findUnitById(e.key);

      if (!unit || unit?.name === item?.goal?.measurement_metric_name) return;

      dispatch(
        UpdateGoal(item?.goal?.id, {
          measurement_metric_name: unit.name || unit.label,
          measurement_start_value: null,
          measurement_current_value: null,
          measurement_target_value: null,
        })
      );
    }
  };

  const handleMeasurementsChange = (field: string, value: any) => {
    dispatch(UpdateGoal(item?.goal?.id, { [field]: value }));
  };

  const handleMeasurementsBulkChange = (values: any, close?: boolean) => {
    dispatch(UpdateGoal(item?.goal?.id, values, () => {
      if (close) {
        handleAssistantClose();
      }
    }));
  };

  const handleAssistantSelect = (items: any) => {
    const { text, value } = items;
    dispatch(
      UpdateGoal(
        item?.goal?.id,
        {
          measurement_metric_name: text,
          measurement_start_value: null,
          measurement_current_value: null,
          measurement_target_value: value,
        },
        () => {
          setTimeout(() => {
            if ($measurement.current) {
              $measurement.current.click();
            }
          }, 100);
        }
      )
    );
  };

  const handleAssistantOpen = (value: boolean) => {
    setIsAssistantOpen(value);
  };

  const handleAssistantClose = () => {
    setIsAssistantOpen(false);
    if ($measurement.current) {
      $measurement.current.click();
    }
  };

  return (
    <>
      <PopoverCustom
        positions={["bottom", "top"]}
        align={isMobile ? "start" : "end"}
        width={isMobile ? "320px" : "448px"}
        reposition={false}
        keepOpen={isAssistantOpen}
        popoverStyle={{
          containerStyle: {
            zIndex: "998",
          },
        }}
        defaultBoundaryElement
        content={
          <UnitsSelector
            key={item?.id}
            id={item?.id}
            predefinedData={predefinedMetrics}
            customData={customMetrics}
            goalData={item?.goal}
            assistant={{
              type: "measurement" as any,
              color: item?.color,
              title: "Measurement",
              order: (i + 1).toString(),
              area: item.name,
              category: item?.goal?.category_name,
              goal: item?.goal?.goal_name,
              onSelect: handleAssistantSelect,
            }}
            onClick={onUnitsChangeHandle}
            onChange={handleMeasurementsChange}
            onBulkChange={handleMeasurementsBulkChange}
            onOpen={handleAssistantOpen}
            onClose={handleAssistantClose}
          />
        }
      >
        <PopoverToggle>
          <InputAreaAI
            id={`measurement_${item?.id}`}
            value={`${
              item?.goal?.measurement_current_value ||
              item?.goal?.measurement_target_value
                ? `${item?.goal?.measurement_current_value ?? " - "}/${
                    item?.goal?.measurement_target_value ?? " - "
                  }`
                : "-"
            } ${item?.goal?.measurement_metric_name}`}
            onChange={() => {}} // Required prop, but readOnly so no-op
            style={{ minWidth: 106, textAlign: "left", marginRight: 100 }}
            assistant={{
              type: "measurement" as any,
              color: item?.color,
              title: "Measurement",
              order: (i + 1).toString(),
              area: item.name,
              category: item?.goal?.category_name,
              goal: item?.goal?.goal_name,
              onSelect: handleAssistantSelect,
            }}
            ref={$measurement}
            readOnly
          />
        </PopoverToggle>
      </PopoverCustom>

      <CreateMetricsPopup
        active={isAddCustomMetric}
        onClose={onAddMetricPopupCloseHandle}
      />
      <ManageMetricsPopup
        active={isManageMetric}
        onClose={onManageToggleHandle}
      />
    </>
  );
};

export default MeasurementForm;
